// extracted by mini-css-extract-plugin
export var modal = "_u5-0";
export var table = "_u5-1";